'use strict';
(function () {
  const  $ = require('jQuery');
  const environment = require('../environment');

  const TooltipKey = Object.freeze({
    VARIABLES: 'variables',
    FUNCTIONS: 'functions',
    SEQUENCES: 'sequences',
    VALUE: 'value',
    IF: 'if',
    WHILE: 'while',
    COUNT: 'count',
    FOREVER: 'forever',
    FROM_DEVICE: 'fromDevice',
    FROM_EXPRESSION: 'fromExpression',
    FROM_EXPRESSION_ARRAY: 'fromExpressionArray',
    TERMINATE: 'terminate',
    HOME: 'home',
    MOVE_ABSOLUTE: 'moveAbsolute',
    MOVE_RELATIVE: 'moveRelative',
    ADD_ACTUATORS: 'addActuators',
    MOVE_TO_CLOSEST_ANGLE: 'moveToClosestAngle',
    DEFINE_ANGLE: 'defineAngle',
    SET_CONTINUOUS_MOVE: 'setContinuousMove',
    STOP_CONTINUOUS_MOVE: 'stopContinuousMove',
    STOP_ALL_MOTION: 'stopAllMotion',
    SET_SPEED: 'setSpeed',
    SET_ACCELERATION: 'setAcceleration',
    MOTION_COMPLETION: 'motionCompletion',
    DIGITAL_INPUT: 'digitalInput',
    DIGITAL_INPUT_EDGE: 'digitalInputEdge',
    AMOUNT_OF_TIME: 'amountOfTime',
    DIGITAL_OUTPUT: 'digitalOutput',
    EXECUTE: 'execute',
    CALL: 'call',
    PUSH: 'push',
    PULL: 'pull',
    IDLE: 'idle',
    ASSIGN_DRIVE_TITLE: `assign_drive_title`,
    ASSIGN_DRIVE_DIRECTION: `assign_drive_direction`,
    ASSIGN_DRIVE_SYNCHRONIZATION: `assign_drive_synchronization`,
    ROBOT_SEQUENCES: `robot_sequences`,
    ROBOT_ARRAYS: `robot_arrays`,
    ROBOT_ARRAY_REFERENCE_FRAME: `robot_array_reference_frame`,
    ROBOT_LOOP: `robot_loop`,
    MOVE_J_AND_L: `move_j_and_l`,
    GLOBAL_REFERENCE_FRAME: `global_reference_frame`,
    LOCAL_REFERENCE_FRAME: `local_reference_frame`,
    DIGITAL_CALIBRATION_TOOLS: `digital_calibration_tools`,
    DIGITAL_CALIBRATION_FLOW: `digital_calibration_flow`,
    FSM_STATE: `fsm_state`,
    FSM_ACTION: `fsm_action`,
    FSM_NEXT_STATE: `fsm_next_state`,
    FSM_TRANSITION_EVENT_TYPE: `fsm_transition_event_type`,
    FSM_CONDITION: `fsm_condition`,
  });


  const gTooltips = {
    [TooltipKey.VARIABLES]: {
      title: 'Variables',
      image: '/variables.jpg',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Variables</strong> tab allows the creation of variables that can be later used in the application’s sequences’ commands.<br><br>' +
              '<strong>Initial Value</strong> allows a numeric value, a string of text, an array, an object, or even a JSON file to be inputted as the initial value of a variable. ' +
              'The <strong>Initial Value</strong> is set at the application level and the value can change throughout the application’s execution.<br><br>' +
              'The <strong>Variable Name</strong> set in this tab could be used under <strong>Set Variable</strong>, <strong>Add Wait</strong>, <strong>Add Loop</strong>, <strong>Add Condition</strong> and <strong>Add Motion</strong> commands.'
          )
        )
      ]
    },
    [TooltipKey.FUNCTIONS]: {
      title: 'Functions',
      // TO-DO update image
      image: '/functions.jpg',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Functions</strong> tab allows the creation of lambda functions that can be later used in the application’s sequences’ commands.<br><br>' +
              '<strong>Arguments</strong> allow names to be passed in the <strong>Function</strong> body. The <strong>Function</strong> body allows Javascript to be entered ' +
              'to return a number, a string, an array or an object. This function can be called in any of the application sequence commands in the following format: FunctionName(Arguments)'
          )
        )
      ]
    },
    [TooltipKey.SEQUENCES]: {
      title: 'Sequences',
      image: '/sequences.jpg',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Sequences</strong> tab allows sequences to be created, renamed, or deleted. This tab also displays the list of sequences within the application.<br><br>' +
              'When executing the application, the main sequence will be executed. To execute a child sequence, it should be called as part of a command under the <strong>Loop</strong>, <strong>Conditions</strong>, or <strong>Execution</strong> category.'
          )
        )
      ]
    },
    [TooltipKey.VALUE]: {
      title: 'Value/Variable',
      image: '/value.jpg',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Value/Variable</strong> allows for a <strong>Variable Name</strong> or numeric value to be inputted as part of a command.'
          )
        )
      ]
    },
    [TooltipKey.IF]: {
      title: 'If',
      image: '/If.jpg',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>If</strong> condition allows a sequence to be executed in series or executed in parallel only if the first <strong>Value/Variable</strong> compared to the second <strong>Value/Variable</strong> is true.<br><br>' +
              '<strong>Else If</strong> allows another <strong>If</strong> statement to be created when the first <strong>If</strong> condition is false. There can be various <strong>Else If</strong> statements, and they will be executed if the previous one is false.<br><br>' +
              '<strong>Else</strong> allows another sequence to be executed in series or executed in parallel when the <strong>If</strong> and all <strong>Else If</strong> conditions are  false.'
          )
        )
      ]
    },
    [TooltipKey.WHILE]: {
      title: 'While',
      image: '/while.jpg',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>While</strong> loop allows sequences to continuously execute while the first <strong>Value/Variable</strong> compared to the second <strong>Value/Variable</strong> is true.'
          )
        )
      ]
    },
    [TooltipKey.COUNT]: {
      title: 'Count',
      image: '/count.jpg',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Count</strong> loop allows the specified sequence to execute the number of times specified under the <strong>Count</strong> field.'
          )
        )
      ]
    },
    [TooltipKey.FOREVER]: {
      title: 'Forever',
      image: '/forever.jpg',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Forever</strong> loop allows the specified sequence to execute continuously for an infinite amount of time.'
          )
        )
      ]
    },
    [TooltipKey.FROM_DEVICE]: {
      title: 'Set Variable from Device',
      image: '/from_device.jpg',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Set Variable</strong> command category allows the <strong>Initial Value</strong> of a variable (set from the <strong>Variables</strong> tab) to change. All the commands executed after this command will use that new value.<br><br>' +
              '<strong>Set Variable from Device</strong> allows a variable to take the value of one input pin of the digital IO module.'
          )
        )
      ]
    },
    [TooltipKey.FROM_EXPRESSION]: {
      title: 'Set Variable from Expression',
      image: '/from_expression.png',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Set Variable</strong> command category allows the <strong>Initial Value</strong> of variables (set from the <strong>Variables</strong> tab) to change. All the commands executed after this command will use that new value.<br><br>' +
              '<strong>Set Variables from Expression</strong> allows variables (set from the <strong>Variables</strong> tab) to take an array of values specified in the <strong>Expression</strong> field. The <strong>Expression</strong> field supports numbers, mathematical operators (*, /, +, -) and <strong>Variable Names</strong>.'
          )
        )
      ]
    },
    [TooltipKey.FROM_EXPRESSION_ARRAY]: {
      title: 'Set Variables from Expression Array',
      image: '/set-variable-from-expression-array.jpg',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Set Variable</strong> command category allows the <strong>Initial Value</strong> of variables (set from the <strong>Variables</strong> tab) to change. All the commands executed after this command will use that new value.<br><br>' +
              '<strong>Set Variables from Expression Array</strong> allows an array of <strong>Variables</strong> (individually defined from the <strong>Variables</strong> tab) to take an array of values specified in the <strong>Expression</strong> field.' +
              'The <strong>Expression</strong> field supports an array of numbers or Variable Names, as well as a lambda function.'
          )
        )
      ]
    },
    [TooltipKey.TERMINATE]: {
      title: 'Terminate',
      image: '/terminate.jpg',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Terminate</strong> command allows the execution of the application to end.<br><br>' +
              '<u>Example</u> : Set up a custom termination sequence on e-stop. In this example, the value of a digital output changes before stopping the application.'
          )
        )
      ]
    },
    [TooltipKey.HOME]: {
      title: 'Move to Home',
      image: '/move_to_home.png',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Move to Home</strong> command allows an actuator to move to its Home position, based on the home sensor position.<br><br>' +
              // FIXME: this does not works as expected: `isOnPendant` is most likely true as `gToolTips` is evaluated before the environment is set
              // FIXME: we will leave it as is for now, if needed, an option could be to wrap the hole object ({title, image, description}) into an anoymous function if some condtional are needed.
              (environment.isOnPendant() ? '' : 'To use this command, a home sensor must be defined in the configuration. ') +
              'In order to set the zero position, <strong>Move to Home</strong> command should be added at the beginning of an application for each actuator.<br><br>' +
              'The speed and acceleration of this command is pre-defined based on the actuator type and cannot be modified by the <strong>Set System Speed</strong> command.'
          )
        )
      ]
    },
    [TooltipKey.MOVE_ABSOLUTE]: {
      title: 'Move to Position',
      image: '/move_to_position.png',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Move to Position</strong> command allows the actuator to move in an absolute position from the home position. Note that a <strong>Move to Home</strong> command is required before adding the <strong>Move to Position</strong> command in the application. <strong>Move to Position</strong> command only allows for a positive value input.<br><br>' +
              'In the following example, the actuator moves from position 250 mm to position 300 mm. The input value for the <strong>Move to Position</strong> command is 300 mm.'
          )
        )
      ]
    },
    [TooltipKey.MOVE_RELATIVE]: {
      title: 'Move Relative',
      image: '/move_relative.png',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Move Relative</strong> command allows the actuator to move to a relative position from its current position. Note that a <strong>Move to Home</strong> command is required before adding the <strong>Move Relative</strong> command in the application. <strong>Move Relative</strong> command accepts both negative or positive input values.<br><br>' +
              'In this example, to move the actuator to position 300 mm (from position 250 mm) the input value to the <strong>Move Relative</strong> command is 50 mm.'
          )
        )
      ]
    },
    [TooltipKey.ADD_ACTUATORS]: {
      title: 'Add Actuators',
      image: '/add_actuators.gif',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Add Actuators</strong> button allows more than one actuator to move at the same time in the command block. The selected actuators will move to their respective position.<br><br>' +
              'Note that each actuator will automatically adjust their speeds for their start and end time to be the same.'
          )
        )
      ]
    },
    [TooltipKey.MOVE_TO_CLOSEST_ANGLE]: {
      title: 'Move to Closest Angle',
      image: '/move_to_closest_angle.jpg',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Move to Closest Angle</strong> command allows the rotary actuator to rotate to the specified position based on the desired direction.<br>' +
              '1. <strong>Positive</strong>: Rotates the motor in a positive direction (set in the configuration tab; default positive is shown in example by looking at the flange of the motor)<br>' +
              '2. <strong>Negative</strong>: Rotates the motor in a negative direction (set in the configuration tab ; default positive is shown in example by looking at the flange of the motor)<br>' +
              '3. <strong>Shortest Path</strong>: Depending on the current position of the rotary actuator, the actuator will rotate either in a negative or positive direction to get to the specified angle.<br><br>' +
              'Please note the rotary actuator will always move less than a full turn. The specified angle needs to be between -360 and 360 deg.<br><br>' +
              'In this example, the rotary actuator is positioned at 140 deg. To move to 0 deg, one of the three commands below could be initiated:<br>' +
              '1. The green arrow if positive direction is chosen<br>' +
              '2. The red arrow if negative direction is chosen<br>' +
              '3. The red arrow if the shortest path is chosen'
          )
        )
      ]
    },
    [TooltipKey.DEFINE_ANGLE]: {
      title: 'Set Angle',
      image: '/set_angle.png',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Set Angle</strong> command allows the rotary actuator position to be set at a specific angular value. This command does not move the rotary actuator, but will override its position value.<br><br>' +
              'In this example, the current rotary actuator was manually positioned to a given position. To set this position at a given angle, for example 0 deg, use the <strong>Set Angle</strong> command.'
          )
        )
      ]
    },
    [TooltipKey.SET_CONTINUOUS_MOVE]: {
      title: 'Start Continuous Move',
      image: '/start_continuous_move.gif',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Start Continuous Move</strong> command allows conveyors and rotary actuators to operate continuously until an event occurs, or for a specified timeframe or when stopped manually.<br><br>' +
              'The speed and acceleration of the <strong>Start Continuous Move</strong> command must be defined as part of the command parameter.<br><br>' +
              'This command will keep executing in the background even when other commands are executed in parallel.<br><br>' +
              'To stop a <strong>Start Continuous Move</strong>, use the <strong>Stop Continuous Move</strong> command or the <strong>Stop All Motion</strong> command.'
          )
        )
      ]
    },
    [TooltipKey.STOP_CONTINUOUS_MOVE]: {
      title: 'Stop Continuous Move',
      image: '/stop_continuous_move.gif',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Stop Continuous Move</strong> command allows to stop a <strong>Start Continuous Move</strong> command for the defined actuator.'
          )
        )
      ]
    },
    [TooltipKey.STOP_ALL_MOTION]: {
      title: 'Stop All Motion',
      image: '/stop_all_motion.gif',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Stop All Motion</strong> command allows all actuator movement commands to stop. This is useful to stop multiple <strong>Set Continuous Move</strong> commands using one command.'
          )
        )
      ]
    },
    [TooltipKey.SET_SPEED]: {
      title: 'Set System Speed',
      image: '/set_speed.jpg',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Set System Speed</strong> command allows all actuators to receive a predefined speed parameter. All subsequent motion commands executed after the <strong>Set System Speed</strong> command will execute at that speed (except <strong>Move to Home</strong> and <strong>Start Continuous Move</strong>), until another <strong>Set System Speed</strong> command is added.'
          )
        )
      ]
    },
    [TooltipKey.SET_ACCELERATION]: {
      title: 'Set System Acceleration',
      image: '/set_acceleration.jpg',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Set System Acceleration</strong> command allows all actuators to receive a predefined acceleration parameter. All subsequent motion commands executed after the <strong>Set System Acceleration</strong> command will execute at that acceleration (except <strong>Start Continuous Move</strong> and <strong>Stop Continuous Move</strong>), until another <strong>Set System Acceleration</strong> command is added.'
          )
        )
      ]
    },
    [TooltipKey.MOTION_COMPLETION]: {
      title: 'Wait for Motion Completion',
      image: '/wait_for_motion_completion.jpg',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Wait for Motion Completion</strong> command allows to wait until all motion commands have completed before performing the next command in the sequence.'
          )
        )
      ]
    },
    [TooltipKey.DIGITAL_INPUT]: {
      title: 'Wait for Digital Input',
      image: '/wait_for_digital_input.jpg',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Wait for Digital Input</strong> command allows the next specified command to execute only if the digital input of an IO module with a specified state (0 or 1) is activated.'
          )
        )
      ]
    },
    [TooltipKey.DIGITAL_INPUT_EDGE]: {
      title: 'Wait for Digital Input Transition',
      image: '/wait_for_digital_input_transition.jpg',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Wait for Digital Input Transition</strong> command allows the next command to only execute if there is a digital input transition state - from 0 to 1 for a <strong>Rising edge</strong>, and from 1 to 0 for a <strong>Falling edge</strong> - before performing the next command in a sequence.'
          )
        )
      ]
    },
    [TooltipKey.AMOUNT_OF_TIME]: {
      title: 'Wait for Amount of Time',
      image: '/wait_for_amount_of_time.jpg',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Wait for Amount of Time</strong> command allows a command or sequence to be executed, only after waiting for a specified amount of time.<br><br>' +
              'In this example, after moving the belt conveyor, the sequence will wait 500 ms before moving the rotary actuator.'
          )
        )
      ]
    },
    [TooltipKey.DIGITAL_OUTPUT]: {
      title: 'Digital Output',
      image: '/add_digital_output.jpg',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Digital output</strong> command allows digital I/O module compatible components to be activated. <br><br>' +
            'In this example,<br>' +
            'STEP 1: In the configuration tab, set up the light tower output displays (red, green and yellow) to have different associated output pins on the digital IO module. <br><br>' +
            'STEP 2: In the main sequence, the conveyor is running until a box is detected. Afterwards, the conveyor will stop running and the tower light will display a red status light. '
          )
        )
      ]
    },
    [TooltipKey.EXECUTE]: {
      title: 'Execute in Series',
      image: '/add_execute_in_series.png',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Execute in Series</strong> command allows a sequence to execute within another sequence and wait for its completion before executing the next command. This is useful for repetitive sequential movements.'
          )
        )
      ]
    },
    [TooltipKey.CALL]: {
      title: 'Execute in Parallel',
      image: '/add_execute_in_parallel.jpg',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Execute in Parallel</strong> command allows sequences to execute in parallel with other sequences.'
          )
        )
      ]
    },
    [TooltipKey.PUSH]: {
      title: 'Push Motion',
      image: '/push.jpg',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Push</strong> command allows the specified pneumatic actuator to extend its piston. The checkbox allows you to specify to wait for the push command to complete before executing the next command. The checkbox will only appear if the position sensors in the configuration menu are configured. <br><br>' +
            'In this example, <br><br>' +
            '"Pneumatic A" will extend its piston and the next command will only execute once the position sensor detects the extended piston.'
          )
        )
      ]
    },
    [TooltipKey.PULL]: {
      title: 'Pull Motion',
      image: '/pull.jpg',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Pull</strong> command allows the specified pneumatic actuator to retract its piston. The checkbox allows you to specify to wait for the pull command to complete before executing the next command. The checkbox will only appear if the position sensors in the configuration menu are configured. <br><br>' +
            'In this example, <br><br>' +
            '"Pneumatic A" will retract its piston and the next command will only execute once the position sensor detects the retracted piston.'
          )
        )
      ]
    },
    [TooltipKey.IDLE]: {
      title: 'Idle Motion',
      image: '/idle.jpg',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Idle</strong> command allows the specified pneumatic actuator to be moved freely by any exerted external force. The pneumatic actuator does not have any air pressure to be retracted nor extended. <br><br>' +
            'In this example, <br><br>' +
            '"Pneumatic A" piston will be able to move freely if a force is exerted to extend or retract the piston. The piston is free to move along its possible travel in this state.  '
          )
        )
      ]
    },
    [TooltipKey.ASSIGN_DRIVE_TITLE]: {
      title: 'Assign & Synchronize Drives',
      image: '',
      hide_glossary: true,
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Note:</strong> Syncing drives assumes the child drive powers the same mechanical actuator as the parent drive.' +
            '<br><br>' +
            'The following parameters need to match for parent/child drives to sync:' +
              '<ul>' +
              '<li>Actuator type</li>' +
              '<li>Motor size</li>' +
              '<li>Gearbox configuration</li>' +
              '<li>Brake configuration</li>' +
              '</ul>'
          )
        )
      ]
    },
    [TooltipKey.ASSIGN_DRIVE_DIRECTION]: {
      title: 'Motor Direction',
      image: '',
      hide_glossary: true,
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Normal:</strong> The gantry is moving to home position towards SENSOR A.' +
            '<br><br>' +
            '<strong>Reverse:</strong> The gantry is moving to home position towards SENSOR B.'
          )
        )
      ]
    },
    [TooltipKey.ASSIGN_DRIVE_SYNCHRONIZATION]: {
      title: 'Synchronization Level',
      image: '',
      hide_glossary: true,
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Parent drive:</strong> The actuator end-stop sensors should be connected to this drive.' +
            '<br><br>' +
            '<strong>Child drive:</strong> There should be no end-stop sensors for this drive; only sensor jumpers.'
          )
        )
      ]
    },
    [TooltipKey.ROBOT_SEQUENCES]: {
      title: 'Robot Paths',
      // Note Audrey : if the image is not defined, the tooltip doesn't appear in the command glossary. We do not want to show robots on ML Edge.
      image: '/robot_sequences.png',
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Robot paths</strong> allow you to create series robot waypoints and actions. Robot paths created at the robot assets level can be reused in the main or child sequences of your program.<br><br>' +
            'In this example, <br><br>' +
            '1. Click on your main/child sequence' +
            '<br></br>' +
            '2. Click “Add a robot path”' +
            '<br></br>' +
            '3. Add waypoints, robot commands in your robot path' +
            '<br></br>' +
            '4. Press play in your main sequence to watch your robot simulate'
          )
        )
      ]
    },
    [TooltipKey.ROBOT_ARRAYS]: {
      title: 'Robot Arrays',
      image: '/robot_arrays.png',
      doNotShowInPendant: true,
      doNotShowInGlossary: true,
      hide_glossary: true,
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Robot arrays</strong> allow you to create a grid of execution points (which could also be referred to as reference frames), where the robot could execute a single “robot path” over each execution point. This robot array is meant to be used with the “Add robot loop” command. <br><br>' +
            '<br><br>' +
            'Fixed spacings array: Creates a 2D pattern that has equal spacing between rows and columns. Select the reference point where you would like the array to be located, fill in the fields and click “Generate”.'
          )
        )
      ]
    },
    [TooltipKey.ROBOT_ARRAY_REFERENCE_FRAME]: {
      title: 'Robot Array Reference Frame',
      image: '/reference_frame.jpg',
      doNotShowInPendant: true,
      doNotShowInGlossary: true,
      hide_glossary: true,
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Robot array reference frames</strong> allow you to specify the coordinate system from which the defined array will be created with respect to. <br><br>'
          )
        )
      ]
    },
    [TooltipKey.ROBOT_LOOP]: {
      title: 'Robot Loop',
      image: '/robot_loops.png',
      doNotShowInPendant: true,
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Robot loops</strong> allow you to repeat a robot path each having their own execution point. <br><br>' +
            'To use a robot loop, define a robot path in a child sequence and a robot array inside robot assets first. <br><br>'
          )
        )
      ]
    },
    [TooltipKey.MOVE_J_AND_L]: {
      title: 'MoveJ and MoveL',
      image: '/MoveJ_and_L_example.gif',
      doNotShowInPendant: true,
      doNotShowInGlossary: true,
      hide_glossary: true,
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>MoveJ</strong> allows you to move your robot in an unrestricted way from the previous waypoint to the current waypoint. <br><br>'
          ),
          $.parseHTML(
            '<strong>MoveL</strong> allows you to move your robot’s end of arm tool in a linear trajectory from the previous waypoint to the current waypoint. <br><br>'
          )
        )
      ]
    },
    [TooltipKey.GLOBAL_REFERENCE_FRAME]: {
      title: 'Global Reference Frame',
      image: '/reference_frame.jpg',
      doNotShowInPendant: true,
      doNotShowInGlossary: true,
      hide_glossary: true,
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Global reference frames</strong> allow you to specify the coordinate system from which the defined waypoints will be created with respect to. The global reference frame is defaulted to the robot base otherwise. <br><br>'
          )
        )
      ]
    },
    [TooltipKey.LOCAL_REFERENCE_FRAME]: {
      title: 'Local Reference Frame',
      image: '/execution_reference_frame.gif',
      doNotShowInPendant: true,
      doNotShowInGlossary: true,
      hide_glossary: true,
      description: [
        $('<div>').append(
          $.parseHTML(
            '<strong>Local reference frames</strong> give you the ability to translate your global reference frame somewhere else in the CAD. This gives you the ability to reuse your taught robot path at different locations. <br><br>'
          )
        )
      ]
    },
    [TooltipKey.DIGITAL_CALIBRATION_TOOLS]: {
      title: 'Digital Calibration Tools',
      image: '/digital_calibration_tool.png',
      doNotShowInPendant: true,
      doNotShowInGlossary: true,
      hide_glossary: true,
      description: [
        $('<div>').append(
          $.parseHTML(
            'A <strong>Digital calibration tool</strong> allows you to accurately deploy your robot program from the cloud environment of MachineBuilder to your factory floor. When deployed and calibrated, the robot will update all waypoints programmed to move with respect to the local coordinate system.' +
            '<br><br>' +
            'For the best results, place the digital calibration tool at the same exact location found in your MachineBuilder design. Then follow the steps found under <strong>How do I Calibrate?</strong> in the jogger to teach the Digital Calibration Tool\'s position.'
          )
        )
      ]
    },
    [TooltipKey.DIGITAL_CALIBRATION_FLOW] : {
      title: 'Digital Calibration Flow',
      image: '/digital_calibration_tool_flow.gif',
      doNotShowInPendant: true,
      doNotShowInGlossary: true,
      hide_glossary: true,
      description: [
        $('<div>').append(
          $.parseHTML(
            `1. Ensure the robot is oriented in the same direction as in your MachineBuilder design by zeroing all the robot's joints, both physically and in MachineBuilder. <br><br>` +
            '2. Install the <strong>Calibration Flange</strong> directly to the robot flange. Ensure the Calibration Flange is mounted inline to the IO connector. <br><br>' +
            '3. Jog to the <strong>Calibration Tool</strong>, aligning the pins on the <strong>Calibration Flange</strong> with the mating holes on the tool. <br><br>' +
            '4. Optional - Insert the locating pin to hold the mated <strong>Calibration Flange</strong> and <strong>Tool</strong> in place. <br><br>' +
            '5. Teach the position in the jogger. <br><br>' +
            '6. Optional - Remove the locating pin. <br><br>' +
            '7. Jog your robot to a safe position, away from any possible collisions, using the Manual Jogger. <br><br>' +
            '8. Play your application in the App Launcher.'
          )
        )
      ]
    },
    [TooltipKey.FSM_STATE] : {
      title: 'State',
      image: '/fsm_diagram.png',
      description: [
        $('<div>').append(
          $.parseHTML(
            `A State is a description of the status of a system waiting to execute a transition to a next state. A system can only be in exactly one of a finite number of states at any given time. In the case of MachineLogic, a state also defines an associated action and a list of it's possible next states.`
          )
        )
      ]
    },
    [TooltipKey.FSM_ACTION] : {
      title: 'Action',
      image: '/fsm_diagram.png',
      description: [
        $('<div>').append(
          $.parseHTML(
            `An Action is a sequence of events that will occur when entering or exiting a given state. In the case of MachineLogic, an action defines a child sequence to be run. Commands can be run either on enter or exit of the state using the Wait For Event command.`
          )
        )
      ]
    },
    [TooltipKey.FSM_NEXT_STATE] : {
      title: 'Next State',
      image: '/fsm_diagram.png',
      description: [
        $('<div>').append(
          $.parseHTML(
            `Next State defines one or many allowable states the current state can safely transition to. Each of these next states define an event, with an optional condition, that triggers a transition.`
          )
        )
      ]
    },
    [TooltipKey.FSM_TRANSITION_EVENT_TYPE] : {
      title: 'Transition Event Type',
      image: '/fsm_diagram.png',
      description: [
        $('<div>').append(
          $.parseHTML(
            `In MachineLogic, the event that triggers a transition can take two forms: <br><br>` +
            `- a <b>Topic</b>, which listens for the exact event defined in the Topic field and transitions when that event is generated, or <br><br>` +
            `- a <b>Digital Input</b>, which waits for a specific digital input pin to have the defined level in order to transition.`
          )
        )
      ]
    },
    [TooltipKey.FSM_CONDITION] : {
      title: 'Condition',
      image: '/fsm_diagram.png',
      description: [
        $('<div>').append(
          $.parseHTML(
            `Also known as a guard, a Condition is an expression that must be met in order to successfully transition. The Condition field can accept a general expression using variables, arithmetic, and/or Lambda functions defined in MachineLogic. If a condition is not met, the transition will not occur and will remain in the same state.`
          )
        )
      ]
    },
  };



  function getTooltipAssetPath() {
    return environment.isOnPendant()
      ? '/images/tooltip'
      : 'https://ventionavatars.s3.amazonaws.com/uploads/tooltip';
  }

  function openTooltipModal(pTip) {
    const lID = 'tooltip_container';
    const lTooltipContainer = $('<div>', {
      id: lID,
      class: 'ml_modal_container'
    })
      .appendTo($('body'))
      .click(function (e) {
        if (e.target === this) {
          $(this).remove();
        }
      });
    const lModal = $('<div>', { class: 'ml_modal' }).appendTo(lTooltipContainer);
    const lContentContainer = $('<div>', { id: lID + '_content' }).appendTo(lModal);

    function lSetTooltip(tooltip) {
      //  optionally dont show the glossary link
      let lCommandGlossaryUi = [];
      if(!tooltip.hide_glossary) {
        lCommandGlossaryUi = [
          $('<div>', {
            class: 'ml_ttp_glossary_link',
            text: 'Command Glossary'
          }),
          $('<div>', {
            class: 'fal fa-long-arrow-right ml_ttp_glossary_link_arrow'
          })
        ];
      }

      lContentContainer.append([
        $('<div>', { class: 'ml_modal_header', text: tooltip.title }),
        $('<hr>', { class: 'ml_ttp_horizontal' }),
        $('<div>', { class: 'ml_modal_body' }).append([
          $('<div>', { class: tooltip.image ? 'ml_ttp_split' : '' }).append([
            $('<div>').append(tooltip.description),
            tooltip.image ? $('<div>', { class: 'ml_ttp_img_frame' }).append($('<img>', { src: getTooltipAssetPath() + tooltip.image })) : ''
          ]),
          $('<div>', { class: 'h_layout ml_ttp_footer' })
            .append(lCommandGlossaryUi)
            .click(function () {
              lContentContainer.children().remove();
              lShowGlossary();
            })
        ])
      ]);
    }

    function lShowGlossary() {
      let _lDefinitions = [];
      Object.keys(gTooltips).sort( function(a,b){ return gTooltips[a].title > gTooltips[b].title ? 1 : -1;} )
        .forEach(function (_pTooltip, index) {
          if (!gTooltips[_pTooltip].image || (gTooltips[_pTooltip].doNotShowInPendant && environment.isOnPendant()) || gTooltips[_pTooltip].doNotShowInGlossary) { /*dont show the tooltip if no image or if not available on pendant*/ return; }

          _lDefinitions = _lDefinitions.concat([
            $('<div>', {
              class:
                'ml_ttp_glossary_grid_child_left ' +
                (index % 2 === 0
                  ? 'ml_ttp_glossary_row_even'
                  : 'ml_ttp_glossary_row_odd')
            }).append(
              $('<div>', {
                class: 'ml_ttp_glossary_title',
                text: gTooltips[_pTooltip].title
              }),
              $('<div>', {
                class: 'ml_ttp_glossary_description'
              }).append(gTooltips[_pTooltip].description)
            ),
            $('<div>', {
              class:
                'ml_ttp_glossary_grid_child_right ' +
                (index % 2 === 0
                  ? 'ml_ttp_glossary_row_even'
                  : 'ml_ttp_glossary_row_odd')
            }).append(
              $('<div>', {
                class: 'ml_ttp_glossary_img'
              }).append(
                $('<img>', {
                  src: getTooltipAssetPath() + gTooltips[_pTooltip].image
                })
              )
            )
          ]);
          index++;
        });

      lContentContainer.append([
        $('<div>', {
          class: 'ml_modal_header ml_ttp_glossary_header',
          text: 'Command Glossary'
        }),
        $('<div>', { class: 'ml_ttp_glossary_body' }).append(
          $('<div>', {
            class: 'ml_ttp_glossary_grid_header_left ml_ttp_glossary_row_odd',
            text: 'Definition'
          }),
          $('<div>', {
            class:
              'ml_ttp_glossary_grid_header_right ml_ttp_glossary_row_odd',
            text: 'Example'
          }),
          _lDefinitions
        )
      ]);
    }

    if (gTooltips[pTip] != undefined) {
      lSetTooltip(gTooltips[pTip]);
    } else {
      lShowGlossary();
    }

    $('<button>', { class: 'far ml_modal_close' })
      .appendTo(lModal)
      .click(function () {
        lTooltipContainer.remove();
      });
  }

  /* Module export glue */
  /* global define */
  const gExports = {
    showTips: openTooltipModal,
    keys: gTooltips,
    TooltipKey: TooltipKey,
  };
  const gModule = typeof module;
  if (gModule !== 'undefined' && module.exports != undefined) {
    module.exports = gExports;
  } else if (
    define != undefined &&
    typeof define === 'function' &&
    define.amd
  ) {
    define([], function () {
      return gExports;
    });
  }
})();
